"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesSelectField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var react_hook_form_1 = require("react-hook-form");
var ControlledMultiSelectField_1 = require("../ControlledMultiSelectField");
exports.CategoriesSelectField = react_1.default.memo(function (_a) {
    var rest = __rest(_a, []);
    var mappedData = [];
    mappedData = Array.from(react_common_lib_1.categories).map(function (el) {
        var _a;
        return ({
            value: el.value,
            text: (_a = el.text) !== null && _a !== void 0 ? _a : '',
            disabled: false,
        });
    });
    var categoriesSelected = (0, react_hook_form_1.useWatch)({
        control: rest.control,
        name: 'categories',
    });
    if (categoriesSelected) {
        var laborSelected = categoriesSelected.find(function (option) { return option.value === 'LABOR'; });
        var overheadLabor = categoriesSelected.find(function (option) { return option.value === 'OVERHEAD_LABOR'; });
        if (laborSelected) {
            var overheadLaborIndex = mappedData.findIndex(function (option) { return option.value === 'OVERHEAD_LABOR'; });
            mappedData[overheadLaborIndex].disabled = true;
        }
        if (overheadLabor) {
            var laborIndex = mappedData.findIndex(function (option) { return option.value === 'LABOR'; });
            mappedData[laborIndex].disabled = true;
        }
    }
    return (0, jsx_runtime_1.jsx)(ControlledMultiSelectField_1.ControlledMultiSelectField, __assign({ error: !!rest.error }, rest, { options: mappedData }));
});
